import Normal from './normal';
import Primary from './primary';
import Text from './text';

export default {
  Normal,
  Primary,
  Text
}
